import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Cliente } from "@/shared/types/cliente";

export async function getCliente(id: string): Promise<Cliente> {
    await sleep(1000);
    const response = await api.get("clientes/" + id);
    return response.data;
}

export function useGetClienteQuery(id: string, queryConfig: QueryConfig<Cliente> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCliente(id),
        queryKey: ["clientes", id],
    })
}

export interface GetClienteQueryProps {
    id: string,
    queryConfig?: QueryConfig<Cliente>,
    children?: (queryResult: QueryResult<Cliente>) => ReactNode
}

export function GetClienteQuery({
    id,
    children,
    queryConfig
}: GetClienteQueryProps) {
    const queryResult = useGetClienteQuery(id, queryConfig);
    return children && children(queryResult);
}